export default {
  I: 'Insurer',
  Q: 'Repairer'
}

export const QuoteTemplateTypeKeys = {
  'Insurer': 'I',
  'Repairer': 'Q'
}